<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="1.5"
      d="M20.767 17.006c0 5.646-3.902 5.187-8.767 5.187-4.819 0-8.766.459-8.766-5.187C3.234 11.361 7.18 6.771 12 6.771c4.82 0 8.767 4.59 8.767 10.235ZM14.432 6.68l1.974-4.269a.452.452 0 0 0-.413-.642H8.328c-.321 0-.55.367-.413.642L9.889 6.68"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="1.5"
      d="M9.292 5.394s3.122-.734 5.738 0M18.242 5.394l-3.81 1.285 3.81.827"
    />
    <path
      fill="currentColor"
      d="M15.26 17.627v-4.44h2.982v.886h-1.977v1.005h1.504v.858h-1.504v1.691h-1.006ZM10.462 17.627v-4.44h1.005v1.704h1.924v-1.704h1.005v4.44h-1.005v-1.824h-1.924v1.824h-1.005ZM9.253 16.183l.685.626a2.18 2.18 0 0 1-.479.466c-.19.142-.406.255-.646.34a2.31 2.31 0 0 1-.772.126c-.448 0-.845-.1-1.191-.3-.342-.2-.61-.472-.806-.818-.19-.351-.286-.75-.286-1.199 0-.328.056-.634.166-.918.111-.289.267-.54.466-.752.205-.213.446-.38.726-.5.284-.12.597-.18.939-.18.408 0 .767.076 1.078.227.31.15.568.368.772.652l-.685.66a1.608 1.608 0 0 0-.473-.447 1.192 1.192 0 0 0-.652-.173c-.267 0-.498.064-.693.193-.19.124-.34.293-.446.506a1.612 1.612 0 0 0-.153.706c0 .262.051.497.153.705.107.209.255.375.446.5.191.12.415.18.673.18.213 0 .39-.03.532-.087.142-.058.262-.131.36-.22.102-.093.197-.19.286-.293Z"
    />
  </svg>
</template>
